export default __webpack_public_path__ + "static/media/curve-line.67c70554.svg";